import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { blogsData } from '../BlogsData/BlogsData';
import './BlogsMobilePreview.scss';

export default function BlogsMobilePreview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const blog = blogsData[parseInt(id)];

  useEffect(() => {
    if (window.innerWidth > 800) {
      navigate('/blog');
    }
  }, [navigate]);

  if (!blog) return <div>Blog not found</div>;

  return (
    <div className="blogs-mobile-preview-container">
      <button onClick={() => navigate(-1)}>Back</button>
      <div className="image-container">
        <img src={blog.image} alt={blog.heading} />
      </div>
      <h2>{blog.heading}</h2>
      {Array.isArray(blog.description) ? (
        blog.description.map((para, idx) => <p key={idx}>{para}</p>)
      ) : (
        <p>{blog.description}</p>
      )}
    </div>
  );
}
